export default {
    list: {
        title: 'Events',
        empty: 'No events',
        cols: {
            name: 'Name',
            startAt: 'Start',
            endAt: 'End',
            status: 'Status'
        }
    },
    status: {
        upcoming: 'Upcoming',
        ongoing: 'Ongoing',
        past: 'Past',
        unknown: 'Unknown'
    },
    filter: {
        search: 'Search',
        status: 'Status',
        from: 'From',
        to: 'To',
        statusOptions: {
            all: 'All',
            upcoming: 'Upcoming',
            ongoing: 'Ongoing',
            past: 'Past'
        }
    },
    actions: {
        newEvent: '+ New event'
    },
    form: {
        name: 'Name',
        startAt: 'Start',
        endAt: 'End',
        errors: {
            endBeforeStart: 'End must be after start'
        },
        warnings: {
            startInPast: 'Start is in the past'
        }
    },
    bzucoSynced: {
        tooltip: 'Synced from external system, cannot delete',
        badge: 'Synced'
    },
    confirm: {
        deleteTitle: 'Delete event?',
        deleteBody: 'Really delete event "{name}"?',
        bulkDeleteTitle: 'Delete selected events?',
        bulkDeleteBody: 'Really delete {n} events?',
        unsavedChanges: 'You have unsaved changes. Close anyway?'
    },
    bulk: {
        selected: '{n} selected',
        deleteSelected: 'Delete selected',
        deleteResult: '{ok} deleted, {failed} failed'
    },
    toast: {
        saved: 'Event saved',
        deleted: 'Event deleted'
    }
}
